import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d835849c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fractional-cd-slider-root" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "inline-block" }
const _hoisted_5 = {
  key: 0,
  class: "screen-reader-only"
}
const _hoisted_6 = { class: "pvd-popover__popover-content-reset" }
const _hoisted_7 = { id: "apy-tooltip-heading" }
const _hoisted_8 = { id: "apy-tooltip-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd3_icon = _resolveComponent("pvd3-icon")!
  const _component_pvd3_popover = _resolveComponent("pvd3-popover")!
  const _component_pvd3_label = _resolveComponent("pvd3-label")!
  const _component_slider = _resolveComponent("slider")!
  const _component_pvd3_field_group = _resolveComponent("pvd3-field-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_pvd3_field_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_pvd3_label, {
          id: _ctx.sliderLabel,
          "pvd-class": "valueSelectedLabel",
          for: _ctx.id
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass(["valueSelected", _ctx.labelSize])
            }, [
              _createElementVNode("span", {
                id: _ctx.leftSliderValue,
                class: "slider-value valueSelectedLeft"
              }, _toDisplayString(_ctx.selectedValue[0]), 9, _hoisted_2),
              _createElementVNode("span", {
                id: _ctx.rightSliderValue,
                class: "slider-value valueSelectedRight"
              }, [
                _createTextVNode(_toDisplayString(_ctx.selectedValue[1]) + " ", 1),
                _createElementVNode("span", _hoisted_4, [
                  (_ctx.selectedValue[1] == '--')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "No rate available"))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode(_component_pvd3_popover, { "pvd-disable-focus": "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.clientConstants.APY_TOOLTIP_HEADING), 1),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.clientConstants.APY_TOOLTIP_TEXT), 1)
                      ]),
                      _createVNode(_component_pvd3_icon, {
                        slot: "trigger",
                        "pvd-a11y-label": "Fractional CD APY annotation",
                        "pvd-name": "action__help",
                        "pvd-size": "small",
                        style: {"color":"#000000"},
                        "pvd-trigger": "",
                        "data-cy": "apy-help-icon"
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.selectedValue[1] && _ctx.selectedValue[1] != '--']
                  ])
                ])
              ], 8, _hoisted_3)
            ], 2)
          ]),
          _: 1
        }, 8, ["id", "for"]),
        _createVNode(_component_slider, {
          id: _ctx.id,
          min: 0,
          max: 5,
          step: 1,
          value: _ctx.currentValueKey,
          values: _ctx.values,
          onSliderValueChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSliderValueChanged($event)))
        }, null, 8, ["id", "value", "values"])
      ]),
      _: 1
    })
  ]))
}